import appsReducer from "./reducer"
import appsSaga from "./sagas"

const sage = {
  reducers: appsReducer,
  sagas: appsSaga
}

export default sage